export function rankShorts(movies, signals) {
  const weights = {};
  Object.values(signals || {}).forEach(signal => {
    (signal.genreIds || []).forEach(id => { weights[id] = (weights[id] || 0) + (signal.preference === 'more' ? 2 : -1); });
  });
  return movies.filter(movie => signals?.[`movie_${movie.id}`]?.preference !== 'hide').map((movie, index) => ({ movie, index, score:(movie.genre_ids || []).reduce((total,id) => total + (weights[id] || 0),0) })).sort((a,b) => b.score-a.score || a.index-b.index).map(entry => entry.movie);
}

export function loadGuestTaste() {
  try { const data = JSON.parse(localStorage.getItem('hedone-short-taste') || '{}'); return data && typeof data === 'object' && !Array.isArray(data) ? data : {}; } catch { return {}; }
}
